<template>
  <div>
    <div class="table-wrapper">
      <b-table
        striped
        bordered
        :fields="fields"
        :items="provider"
        :per-page="perPage"
        :current-page="currentPage"
        sort-icon-left
        id="score-table"
      >
        <template #cell()="data">
          <span class="text-center">{{ data.value }}</span>
        </template>
      </b-table>
    </div>
    <br />
    <b-pagination
      class="pagination"
      v-model="currentPage"
      :total-rows="totalCount"
      :per-page="perPage"
      aria-controls="score-table"
    />
  </div>
</template>

<script>
  import { BPagination } from 'bootstrap-vue';

  import { mapActions, mapGetters } from 'vuex';

  export default {
    props: ['versionKey', 'skills'],
    components: {
      BPagination,
    },
    data() {
      return {
        currentPage: 1,
        totalCount: 0,
        perPage: 10,
        sortByAndDir: {},
      };
    },
    methods: {
      ...mapActions('editMode/version', ['getAllUsersData']),
      async provider(ctx) {
        const { currentPage, perPage, sortBy, sortDesc } = ctx;

        await this.getAllUsersData({
          versionKey: this.versionKey,
          currPage: currentPage,
          perPage,
          sortBy,
          sortDesc,
        });

        this.sortByAndDir.sortBy = sortBy;
        this.sortByAndDir.direction = sortDesc ? 'desc' : 'asc';
        this.$emit('tableAttr', this.sortByAndDir);

        const parsedScores = this.getAllUsersInfo.map((score) => {
          const zoneName = this.$dayjs.tz.guess();
          return {
            ...score,
            dateCompleted: this.$dayjs(score.dateCompleted).tz(zoneName).format('MM/DD/YY'),
          };
        });

        this.totalCount = this.getTotalUsersCount;

        return parsedScores;
      },
    },

    computed: {
      ...mapGetters('editMode/version', ['getAllUsersInfo', 'getTotalUsersCount']),
      fields() {
        const baseFields = [
          {
            key: 'studentKey',
            label: 'User Key',
            sortable: true,
          },
          {
            key: 'simID',
            label: 'SimID',
          },
          {
            key: 'dateCompleted',
            sortable: true,
          },
        ];
        Object.values(this.skills).forEach((skill) =>
          baseFields.push({
            key: String(skill.skillKey),
            label: skill.name,
            sortable: true,
          })
        );
        baseFields.push({
          key: 'overall',
          label: 'Overall Score',
          sortable: true,
        });

        return baseFields.map((field) => ({
          ...field,
          thClass: 'text-center',
          tdClass: 'text-center',
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'node_modules/bootstrap/scss/bootstrap.scss';
  @import 'node_modules/bootstrap-vue/src/index.scss';

  @mixin border-left-radius() {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  // Temporary fix for button height not being applied correctly from Bootstrap
  ::v-deep .page-item > button {
    height: 100%;
  }

  $border-radius: 0.25rem !default;

  ::v-deep .page-item {
    &:first-child {
      .page-link {
        margin-left: 0;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
    }
    &:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }

    &.active .page-link {
      z-index: 3;
      color: #fff;
      background-color: #007bff;
      border-color: #007bff;
    }
  }

  ::v-deep .page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #007bff;

    &:hover {
      z-index: 2;
      color: darken(#007bff, 15%);
      text-decoration: none;
      background-color: #e9ecef;
      // border-color: #dee2e6;
    }

    &:focus {
      z-index: 3;
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(#007bff, 0.25);
    }
  }
  .table-wrapper {
    width: 100%;
    overflow: auto;
    position: relative;
  }
</style>
